import React from "react";

interface Props {
  email: server.dto.EmailMessage
  shortBody: string
}

const EmailPreview = ({ email, shortBody }: Props) => {
  const domParser = new DOMParser();

  // For a preview, we don't actually want render the HTML. We just want the raw text.
  // For example if the text is very large, it will overflow
  const dom = domParser.parseFromString(shortBody, "text/html");
  const text = dom.documentElement.innerText;

  return <>
    <table className="s1_emailheader margin-bottom-mini">
      <tbody>
        <tr>
          <td className="s1_gray">{RESX.Message.lblTo}:</td>
          <td>{email.recipientsTo}</td>
        </tr>
        <tr>
          <td className="s1_gray">{RESX.Message.Subject}:</td>
          <td>{email.subject}</td>
        </tr>
      </tbody>
    </table>
    <div className="s1_small truncate">{text}</div>
  </>;
};

export default EmailPreview;